//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'select-member-modal',
    components: {},
    props: {
        onSelected: Function
    },
    data() {
        return {
            loading: false,
            saving: false,
            searchInput: {},

            columns: [
                {
                    // title: 'Id',
                    // key: 'id',
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    key: 'name',
                    title: '姓名', align: 'center'
                },
                {
                    key: 'phoneNumber',
                    title: '手机号', align: 'center',minWidth:100
                },
                {
                    key: '',
                    title: 'uid',
                    align: 'center',
                    render: (h, params) => {
                        return h('span', params.row.id + 10000);
                    }
                },
                // {
                //     title: '生日',
                //     render: (h, params) => {
                //         const row = params.row;
                //         if (row.brithDay != null) {
                //             return h('span', new Date(row.brithDay).toLocaleDateString());
                //         } else {
                //             return h('span', '');
                //         }
                //
                //     }
                // },
                // {
                //     title: '会员等级',
                //     key: 'memberLevelStr'
                // },
                {
                    title: '创建日期',
                    key: 'creationTimeStr', align: 'center',minWidth:100
                }
            ]
        };
    },
    computed: {
        list() {
            return this.$store.state.member.list;
        },
        currentPage() {
            return this.$store.state.member.currentPage;
        },
        pageSize() {
            return this.$store.state.member.pageSize;
        },
        totalCount() {
            return this.$store.state.member.totalCount;
        }
    },
    methods: {
        pageChange(page) {
            this.$store.commit('member/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('member/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            await this.$store.dispatch({
                type: 'member/getAll',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        onRowClick(row, index) {
            const vm = this;
            if (vm.onSelected !== undefined) {
                vm.onSelected(row);
            }
        }
    },
    created() {
        this.getPage();
    }
};
